/**
 * 用户状态管理工具
 * 使用localStorage存储用户信息和token
 */

const STORAGE_KEYS = {
  TOKEN: 'token',
  USER_INFO: 'userInfo'
};

/**
 * 保存用户登录信息
 * @param {Object} userInfo - 用户信息对象
 * @param {string} token - 用户token
 */
export const saveUserInfo = (userInfo, token) => {
  localStorage.setItem(STORAGE_KEYS.TOKEN, token);
  localStorage.setItem(STORAGE_KEYS.USER_INFO, JSON.stringify(userInfo));
};

/**
 * 获取用户信息
 * @returns {Object|null} 用户信息对象，如果未登录返回null
 */
export const getUserInfo = () => {
  const userInfoStr = localStorage.getItem(STORAGE_KEYS.USER_INFO);
  if (!userInfoStr) {
    return null;
  }
  
  try {
    return JSON.parse(userInfoStr);
  } catch (error) {
    console.error('解析用户信息失败:', error);
    return null;
  }
};

/**
 * 获取用户token
 * @returns {string|null} 用户token，如果未登录返回null
 */
export const getToken = () => {
  return localStorage.getItem(STORAGE_KEYS.TOKEN);
};

/**
 * 检查用户是否已登录
 * @returns {boolean} 是否已登录
 */
export const isLoggedIn = () => {
  const token = getToken();
  const userInfo = getUserInfo();
  return !!(token && userInfo);
};

/**
 * 清除用户登录信息
 */
export const clearUserInfo = () => {
  localStorage.removeItem(STORAGE_KEYS.TOKEN);
  localStorage.removeItem(STORAGE_KEYS.USER_INFO);
};

/**
 * 获取用户昵称或用户名
 * @returns {string} 用户昵称或用户名
 */
export const getUserName = () => {
  const userInfo = getUserInfo();
  return userInfo?.nickname || userInfo?.username || '用户';
};

/**
 * 获取用户首字母（用于头像）
 * @returns {string} 用户名首字母
 */
export const getUserInitial = () => {
  const name = getUserName();
  return name.charAt(0).toUpperCase();
};

export default {
  saveUserInfo,
  getUserInfo,
  getToken,
  isLoggedIn,
  clearUserInfo,
  getUserName,
  getUserInitial
};
